var borderWidths = [0, 1];
// https://medium.com/free-code-camp/the-100-correct-way-to-do-css-breakpoints-88d6a5ba1862
var breakpoints = ["600px", "900px", "1200px", "1800px"];
var namedBreakpointIndexes = { sm: 0, md: 1, lg: 2, xl: 3 };
var duration = [
    "0ms",
    "50ms",
    "100ms",
    "150ms",
    "200ms",
    "250ms",
    "300ms",
    "350ms",
    "400ms",
    "450ms",
    "500ms",
];
var space = [
    "0",
    "4px",
    "6px",
    "8px",
    "12px",
    "16px",
    "24px",
    "32px",
    "48px",
    "64px",
];
var radii = [0, 2, 4, 6, 8];
var sizes = [
    "0",
    "4px",
    "6px",
    "8px",
    "12px",
    "16px",
    "24px",
    "32px",
    "48px",
    "64px",
];
var shadows = [
    "0 0 0 4px var(--colors-focus-shadow)",
    "0 2px 4px 0 var(--colors-shadow), 0 1px 2px 0 var(--colors-shadow)",
    "0 4px 8px 0 var(--colors-shadow), 0 2px 4px 0 var(--colors-shadow)",
    "0 8px 16px 0 var(--colors-shadow), 0 4px 8px 0 var(--colors-shadow)",
    "0 16px 32px 2px var(--colors-shadow), 0 8px 16px 2px var(--colors-shadow)",
    "0 24px 48px 6px var(--colors-shadow), 0 12px 24px 6px var(--colors-shadow)",
    "0 32px 64px 10px var(--colors-shadow), 0 24px 48px 10px var(--colors-shadow)", // 32dp
];
var zIndices = {
    base: 0,
    sticky: 10,
    popover: 30,
    layoutSidebar: 60,
    layoutHeader: 50,
    modal: 70, // sits over everything
};

export { borderWidths, breakpoints, duration, namedBreakpointIndexes, radii, shadows, sizes, space, zIndices };
//# sourceMappingURL=scales.js.map
